// extracted by mini-css-extract-plugin
module.exports = {"component":"drag-scroll_component__tGaTE"};